<h1>Документы</h1>
<div *ngIf="leagueDocuments.length !== 0">
  <div class="document-table" *ngIf="leagueDocuments.length">
    <div class="content">
      <div class="table-row" *ngFor="let document of leagueDocuments;let i = index">

        <div class="table-col main">
          <mtg-svg-icon *ngIf="isPdf(document.file)" icon="icons-pdf-file" class="icon"></mtg-svg-icon>
          <mtg-svg-icon *ngIf="isImg(document.file)" icon="icons-img-file" class="icon"></mtg-svg-icon>
          <mtg-svg-icon *ngIf="!isPdf(document.file) && !isImg(document.file)" icon="icons-doc-file" class="icon"></mtg-svg-icon>
          <a [href]="document.file.path" class="download" (click)="downloadFile(document.file, $event)">
            <div>{{document.file.originalName}}</div>
          </a>
        </div>
<!--        <div class="table-col muted">-->
<!--          Загружен {{document.file.createdAt | date: 'd&nbsp;MMM yyyy' }}-->
<!--        </div>-->
        <div class="table-col muted">
          {{document.file.mimeType.split('/').pop().toUpperCase()}}&nbsp;•&nbsp;{{getFileSize(document.file.size)}}
        </div>
      </div>
    </div>
  </div>
</div>
<router-outlet></router-outlet>
